export default __webpack_public_path__ + "static/media/1170.73fc07a7.png";